import {ChangeDetectionStrategy, Component, computed, inject, input, PLATFORM_ID} from '@angular/core';
import {isPlatformServer} from "@angular/common";
import {marked} from "marked";
import {ArticleService} from "../../../services/article.service";
import {NgComponentOutlet} from "@angular/common";
import {
  LotteriesAndFooterComponent
} from "../../../components/lotteries-and-footer/lotteries-and-footer.component";
import {httpResource} from "@angular/common/http";
import {injectSsrRequestContext, ONE_WEEK} from "../../../ssr-cache-utils";
import {environment} from "../../../../../environments/environment";

@Component({
  selector: 'homey-article-page',
  imports: [
    LotteriesAndFooterComponent,
    NgComponentOutlet
  ],
  templateUrl: './article-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ArticlePageComponent {
  private readonly articleService = inject(ArticleService);
  private readonly isServer = isPlatformServer(inject(PLATFORM_ID));
  public readonly slug = input.required<string>();
  private readonly article = computed(() => this.articleService.getArticle(this.slug())!);
  public readonly customComponent = computed(() => this.articleService.getCustomComponent(this.slug()));

  constructor() {
    const context = injectSsrRequestContext();
    if (context) {
      context.cacheDuration = ONE_WEEK;
    }
  }

  private readonly markdownResource = httpResource.text(() => {
    const articlePath = this.customComponent() ? undefined : this.article()?.article;
    if (!articlePath) return undefined;
    return this.isServer ? `${environment.baseUrl}${articlePath}` : articlePath;
  });

  public readonly markdown = computed(() => {
    const raw = this.markdownResource.value();
    return raw ? marked.parse(raw, {async: false}) : '';
  });
}
